import { createI18n } from 'vue-i18n';
import en from './en.json';
import id from './id.json';

// Get the saved language from localStorage or default to 'id'
const savedLanguage = localStorage.getItem('language') || 'id';

const i18n = createI18n({
	legacy: false,
	locale: savedLanguage,
	globalInjection: true,
	messages: {
		en,
		id,
	},
});

export default i18n;
